import { useTypedSelector } from "../hooks";

export const useTokenId = (): string =>
  useTypedSelector(({ auth }) => auth?.tokenId);
